/**
 * Automotive panel widgets — alerts.
 */
import { registerAutomotive } from '../../registryCore';
import { addListRow, addPanelFrame, addPanelTitle, finishPanel, panelBounds, panelGroup, panelTheme, } from '../panelPrimitives';
import { lines } from './shared';
registerAutomotive('warningAlertPanel', function (props, app) {
    var _a;
    var theme = panelTheme(props);
    var bounds = panelBounds(props, 220, 120);
    var group = panelGroup(app, 'warningAlertPanel', props, bounds);
    var pad = bounds.pad, w = bounds.innerWidth, h = bounds.innerHeight;
    var alerts = (_a = props.alerts) !== null && _a !== void 0 ? _a : lines(props, ['No warnings']);
    var hasAlert = alerts.length > 0 && alerts[0].toLowerCase() !== 'no warnings';
    addPanelFrame(group, app, bounds, theme);
    var startY = addPanelTitle(group, app, bounds, theme, 'Warnings');
    var rowH = Math.max(24, (pad + h - startY - 4) / Math.min(2, alerts.length));
    alerts.slice(0, 2).forEach(function (alert, i) {
        addListRow(group, app, pad, startY + i * (rowH + 4), w, rowH, '⚠', alert, undefined, theme, hasAlert && i === 0);
    });
    return finishPanel(group, props, bounds, { alerts: alerts });
});
registerAutomotive('notificationCenter', function (props, app) {
    var _a;
    var theme = panelTheme(props);
    var bounds = panelBounds(props, 220, 140);
    var group = panelGroup(app, 'notificationCenter', props, bounds);
    var pad = bounds.pad, w = bounds.innerWidth, h = bounds.innerHeight;
    var items = (_a = props.notifications) !== null && _a !== void 0 ? _a : [
        { icon: '⚠', text: 'Tire pressure low — FL', time: '2m' },
        { icon: '♪', text: 'Bluetooth connected', time: '8m' },
        { icon: '☁', text: 'Weather alert nearby', time: '15m' },
    ];
    addPanelFrame(group, app, bounds, theme);
    var startY = addPanelTitle(group, app, bounds, theme, "Notifications (".concat(items.length, ")"));
    var rowH = Math.max(28, (pad + h - startY - 4) / Math.min(3, items.length) - 4);
    items.slice(0, 3).forEach(function (item, i) {
        addListRow(group, app, pad, startY + i * (rowH + 4), w, rowH, item.icon, item.text, item.time, theme, i === 0);
    });
    return finishPanel(group, props, bounds, { notifications: items });
});
